const StoreConfig = {
  'store.list.list': {
    operation: ['VISIBLE'],
    title: '大列表',
    c: {
      type: 'constant',
      value: 'list',
    },
    getParse_category: {
      type: 'variable',
      func: function (item = {}, visibleData, args) {
        if (item.item.type === 'blank' || item.item?.data?.length > 1) {
          return [];
        }
        const data = {
          type: 'tour',
          isViewable: item.isViewable,
          key: 'tour' + item.index,
          index: item.item?.d - 1,
          iid: `u=${encodeURIComponent(
            `https://m.mi.com/mfbs/mstd/product?commodityId=${item.item?.productId}&defaultStoreId=${item.item?.storeId}`,
          )}&next=product.${item.item?.productId}&org_id=${item.item?.storeId}&label=${encodeURIComponent(
            (item.item.tags || []).map((_item) => _item.name).join('&'),
          )}`,
          b: 'store',
          c: 'tour',
          d: item.item.d,
        };
        return [data];
      },
    },
    getParse_recommendItem: {
      type: 'variable',
      func: function (item = {}, visibleData, args) {
        if (!item?.item?.length) {
          return null;
        }
        const res = [];
        item?.item?.forEach((_item) => {
          res.push({
            type: 'feed',
            isViewable: item.isViewable,
            key: 'feed' + _item?.data?.goods?.d,
            index: _item?.data?.goods?.d - 1,
            iid: `u=${encodeURIComponent(
              `https://m.mi.com/mfbs/mstd/product?commodityId=${_item?.data?.goods?.id}&defaultStoreId=${_item?.data?.goods?.curStoreId}`,
            )}&next=product.${_item?.data?.goods?.id}&org_id=${_item?.data?.goods?.curStoreId}`,
            b: 'store',
            c: 'feed',
            d: _item.d,
            scmv2: _item?.data?.goods?.action?.spmStat?.scm,
          });
        });
        return res;
      },
    },
  },
  'store.map.map_pop': {
    operation: ['TOUCH', 'VISIBLE'],
    title: '地图导航选择弹层',
    c: {
      type: 'constant',
      value: 'map_pop',
    },
    d: {
      type: 'variable',
      func: ({ d }) => {
        return d;
      },
    },
    iid: {
      type: 'variable',
      func: function getIid(traceData) {
        const { type } = traceData;
        return `map_type=${type || ''}`;
      },
    },
  },
  'store.map.map_pop_cancel': {
    operation: ['TOUCH', 'VISIBLE'],
    title: '地图导航选择弹层取消',
    c: {
      type: 'constant',
      value: 'map_pop_cancel',
    },
    d: {
      type: 'constant',
      value: '1',
    },
  },
  'store.left_nav.list': {
    operation: ['VISIBLE'],
    title: '列表',
    c: {
      type: 'constant',
      value: 'list',
    },
    getParse: {
      type: 'variable',
      func: function (item = {}, visibleData, args) {
        const data = {
          type: 'menu',
          isViewable: item.isViewable,
          key: 'menu' + item.index,
          index: item.index,
          iid: `org_id=${item?.item?.storeId || ''}&catalog=${item?.item?.catId}`,
          b: 'store',
          c: 'menu',
          d: item.index + 1,
        };
        return [data];
      },
    },
  },
  'store.left_nav.item': {
    operation: ['TOUCH'],
    title: '点击',
    c: {
      type: 'constant',
      value: 'menu',
    },
    d: {
      type: 'variable',
      func: ({ index }) => {
        return index + 1;
      },
    },
    iid: {
      type: 'variable',
      func: function getIid(traceData) {
        const { item } = traceData;
        return `org_id=${item?.storeId || ''}&catalog=${item?.catId}`;
      },
    },
  },
  'store.category.item': {
    operation: ['TOUCH'],
    title: '点击',
    c: {
      type: 'constant',
      value: 'tour',
    },
    d: {
      type: 'variable',
      func: function getIid(traceData) {
        const { item } = traceData;

        return item.d;
      },
    },
    iid: {
      type: 'variable',
      func: function getIid(traceData) {
        const { item } = traceData;
        return `u=${encodeURIComponent(
          `https://m.mi.com/mfbs/mstd/product?commodityId=${item?.productId}&defaultStoreId=${item?.storeId}`,
        )}&next=product.${item?.productId}&org_id=${item?.storeId}&label=${encodeURIComponent(
          (item.tags || []).map((_item) => _item.name).join('&'),
        )}`;
      },
    },
  },
  'store.main.prev': {
    operation: ['TOUCH', 'VISIBLE'],
    title: '点击',
    c: {
      type: 'constant',
      value: 'prev',
    },
    iid: {
      type: 'variable',
      func: function getIid(traceData) {
        const { storeId } = traceData;
        return `org_id=${storeId || ''}`;
      },
    },
  },
  'store.main.search': {
    operation: ['TOUCH', 'VISIBLE'],
    title: '点击',
    c: {
      type: 'constant',
      value: 'search',
    },
    iid: {
      type: 'variable',
      func: function getIid(traceData) {
        const { storeId, u } = traceData;
        return `org_id=${storeId || ''}&u=${encodeURIComponent(u)}`;
      },
    },
  },
  'store.main.share': {
    operation: ['TOUCH', 'VISIBLE'],
    title: '点击',
    c: {
      type: 'constant',
      value: 'share',
    },
    iid: {
      type: 'variable',
      func: function getIid(traceData) {
        const { storeId } = traceData;
        return `org_id=${storeId || ''}`;
      },
    },
  },
  'store.main.shift': {
    operation: ['TOUCH', 'VISIBLE'],
    title: '点击',
    c: {
      type: 'constant',
      value: 'shift',
    },
    iid: {
      type: 'variable',
      func: function getIid(traceData) {
        const { storeId } = traceData;
        return `org_id=${storeId || ''}`;
      },
    },
  },
  'store.main.contact': {
    operation: ['TOUCH', 'VISIBLE'],
    title: '点击',
    c: {
      type: 'constant',
      value: 'contact',
    },
    iid: {
      type: 'variable',
      func: function getIid(traceData) {
        const { storeId } = traceData;
        return `org_id=${storeId || ''}`;
      },
    },
  },
  'store.main.map': {
    operation: ['TOUCH', 'VISIBLE'],
    title: '地图',
    c: {
      type: 'constant',
      value: 'map',
    },
    iid: {
      type: 'variable',
      func: function getIid(traceData) {
        const { storeId } = traceData;
        return `org_id=${storeId || ''}`;
      },
    },
  },
  'store.main.tel': {
    operation: ['TOUCH', 'VISIBLE'],
    title: '电话',
    c: {
      type: 'constant',
      value: 'tele',
    },
    iid: {
      type: 'variable',
      func: function getIid(traceData) {
        const { tel } = traceData;
        return `tele=${tel || ''}`;
      },
    },
  },
  'store.main.tab': {
    operation: ['TOUCH', 'VISIBLE'],
    title: '点击',
    c: {
      type: 'constant',
      value: 'tab',
    },
    d: {
      type: 'variable',
      func: function getIid(traceData) {
        return traceData.d;
      },
    },
    iid: {
      type: 'variable',
      func: function getIid(traceData) {
        const { storeId, tag } = traceData;
        return `org_id=${storeId || ''}&tag=${encodeURIComponent(tag || '')}`;
      },
    },
  },
  'store.main.tab_touch': {
    operation: ['TOUCH'],
    title: '点击',
    c: {
      type: 'constant',
      value: 'tab',
    },
    d: {
      type: 'variable',
      func: function getIid(traceData) {
        return traceData.d;
      },
    },
    iid: {
      type: 'variable',
      func: function getIid(traceData) {
        const { storeId, tag } = traceData;
        return `org_id=${storeId || ''}&tag=${encodeURIComponent(tag || '')}`;
      },
    },
  },
  'store.main.address_tab': {
    operation: ['TOUCH', 'VISIBLE'],
    title: '点击',
    c: {
      type: 'constant',
      value: 'mode',
    },
    d: {
      type: 'variable',
      func: function getIid(traceData) {
        return traceData.d;
      },
    },
    iid: {
      type: 'variable',
      func: function getIid(traceData) {
        const { storeId } = traceData;
        return `org_id=${storeId || ''}`;
      },
    },
  },
  'store.main.storelist_tab': {
    operation: ['TOUCH', 'VISIBLE'],
    title: '店铺列表tab',
    c: {
      type: 'constant',
      value: 'store_conditions',
    },
    d: {
      type: 'variable',
      func: function getIid(traceData) {
        return traceData.d;
      },
    },
  },
  'store.main.address_select': {
    operation: ['TOUCH', 'VISIBLE'],
    title: '点击',
    c: {
      type: 'constant',
      value: 'address',
    },
    iid: {
      type: 'variable',
      func: function getIid(traceData) {
        const { storeId } = traceData;
        return `org_id=${storeId || ''}`;
      },
    },
  },
  'store.main.store_item': {
    operation: ['TOUCH'],
    title: '点击',
    c: {
      type: 'constant',
      value: 'sheet',
    },
    d: {
      type: 'variable',
      func: function getIid(traceData) {
        return traceData.d;
      },
    },
    iid: {
      type: 'variable',
      func: function getIid(traceData) {
        const { storeId, selfId, currentTab, oftenBuy } = traceData;
        return `org_id=${storeId || ''}&store_id=${selfId}&store_conditions=${currentTab === 'near' ? 1 : 2}${
          oftenBuy ? '&often_buy=true' : ''
        }`;
      },
    },
  },
  'store.store.list': {
    operation: ['VISIBLE'],
    title: '列表',
    c: {
      type: 'constant',
      value: 'list',
    },
    getParse: {
      type: 'variable',
      func: function (item = {}, visibleData, args) {
        const { traceObj } = args;
        const data = {
          type: 'menu',
          isViewable: item.isViewable,
          key: 'menu' + item.index,
          index: item.index,
          iid: `org_id=${item?.item?.currentStoreCode || ''}&store_id=${item?.item?.storeNo}&store_conditions=${
            traceObj?.currentTab === 'near' ? 1 : 2
          }${item?.item?.freqBoughtStore ? '&often_buy=true' : ''}`,
          b: 'store',
          c: 'sheet',
          d: item.item.d,
        };
        return [data];
      },
    },
  },
  'store.main.staff_item': {
    operation: ['TOUCH', 'VISIBLE'],
    title: '点击',
    c: {
      type: 'constant',
      value: 'wechat',
    },
    d: {
      type: 'variable',
      func: function (traceData) {
        return traceData.d;
      },
    },
    iid: {
      type: 'variable',
      func: function getIid(traceData) {
        const { orgId, staffId } = traceData;
        return `org_id=${orgId || ''}&staff_id=${staffId}`;
      },
    },
  },
  'store.main.swiper_banner': {
    operation: ['VISIBLE'],
    title: '曝光',
    c: {
      type: 'constant',
      value: 'banner',
    },
  },
  'store.main.swiper_banner': {
    operation: ['TOUCH'],
    title: '点击',
    c: {
      type: 'constant',
      value: 'banner',
    },
    d: {
      type: 'variable',
      func: function (traceData) {
        return traceData.d;
      },
    },
    iid: {
      type: 'variable',
      func: function getIid(traceData) {
        const { orgId, u } = traceData;
        return `org_id=${orgId || ''}&u=${encodeURIComponent(u)}`;
      },
    },
  },
  'store.main.tonew_title': {
    operation: ['TOUCH', 'VISIBLE'],
    title: '点击',
    c: {
      type: 'constant',
      value: 'release',
    },
    d: {
      type: 'variable',
      func: function getIid(traceData) {
        return traceData.d;
      },
    },
    iid: {
      type: 'variable',
      func: function getIid(traceData) {
        const { storeId, u } = traceData;
        return `org_id=${storeId || ''}&u=${encodeURIComponent(u)}`;
      },
    },
  },
  'store.tonew.list_item': {
    operation: ['TOUCH'],
    title: '点击',
    c: {
      type: 'constant',
      value: 'release_sugitem',
    },
    d: {
      type: 'variable',
      func: function getIid(traceData) {
        return traceData.d;
      },
    },
    iid: {
      type: 'variable',
      func: function getIid(traceData) {
        const { storeId, productId } = traceData;
        return `org_id=${storeId || ''}&next=product.${productId}&u=${encodeURIComponent(
          `https://m.mi.com/mfbs/mstd/product?commodityId=${productId}&defaultStoreId=${storeId}`,
        )}`;
      },
    },
  },
  'store.torecommend.list_item': {
    operation: ['TOUCH'],
    title: '点击',
    c: {
      type: 'constant',
      value: 'manager_sugitem',
    },
    d: {
      type: 'variable',
      func: function getIid(traceData) {
        return traceData.d;
      },
    },
    iid: {
      type: 'variable',
      func: function getIid(traceData) {
        const { storeId, productId } = traceData;
        return `org_id=${storeId || ''}&next=product.${productId}&u=${encodeURIComponent(
          `https://m.mi.com/mfbs/mstd/product?commodityId=${productId}&defaultStoreId=${storeId}`,
        )}`;
      },
    },
  },
  'store.main.recommend_title': {
    operation: ['TOUCH', 'VISIBLE'],
    title: '点击',
    c: {
      type: 'constant',
      value: 'manager',
    },
    d: {
      type: 'variable',
      func: function getIid(traceData) {
        return traceData.d;
      },
    },
    iid: {
      type: 'variable',
      func: function getIid(traceData) {
        const { storeId } = traceData;
        return `org_id=${storeId || ''}`;
      },
    },
  },
  'store.tonew.list': {
    operation: ['VISIBLE'],
    title: '列表',
    c: {
      type: 'constant',
      value: 'list',
    },
    getParse: {
      type: 'variable',
      func: function (item = {}, visibleData, args) {
        const data = {
          type: 'release_sugitem',
          isViewable: item.isViewable,
          key: 'release_sugitem' + item.index,
          index: item.index,
          iid: `org_id=${args?.traceObj?.storeId}&next=product.${item?.item?.productId}&u=${encodeURIComponent(
            `https://m.mi.com/mfbs/mstd/product?commodityId=${item?.item?.productId}&defaultStoreId=${args?.traceObj?.storeId}`,
          )}`,
          b: 'store',
          c: 'release_sugitem',
          d: item.index + 1,
        };
        return [data];
      },
    },
  },
  'store.torecommend.list': {
    operation: ['VISIBLE'],
    title: '列表',
    c: {
      type: 'constant',
      value: 'list',
    },
    getParse: {
      type: 'variable',
      func: function (item = {}, visibleData, args) {
        const data = {
          type: 'manager_sugitem',
          isViewable: item.isViewable,
          key: 'manager_sugitem' + item.index,
          index: item.index,
          iid: `org_id=${args?.traceObj?.storeId}&next=product.${item?.item?.productId}&u=${encodeURIComponent(
            `https://m.mi.com/mfbs/mstd/product?commodityId=${item?.item?.productId}&defaultStoreId=${args?.traceObj?.storeId}`,
          )}`,
          b: 'store',
          c: 'manager_sugitem',
          d: item.index + 1,
        };
        return [data];
      },
    },
  },
  'store.main.feed_item': {
    operation: ['TOUCH'],
    title: '点击',
    c: {
      type: 'constant',
      value: 'feed',
    },
    d: {
      type: 'variable',
      func: function getIid(traceData) {
        const { item } = traceData;
        return item?.data?.goods?.d;
      },
    },
    iid: {
      type: 'variable',
      func: function getIid(traceData) {
        const { item } = traceData;
        return `org_id=${item?.data?.goods?.curStoreId || ''}&next=product.${
          item?.data?.goods?.id
        }&u=${encodeURIComponent(
          `https://m.mi.com/mfbs/mstd/product?commodityId=${item?.data?.goods?.id}&defaultStoreId=${
            item?.data?.goods?.curStoreId || ''
          }`,
        )}`;
      },
    },
    scm: {
      type: 'variable',
      func: (traceData) => {
        const { item } = traceData;
        return item?.data?.goods?.action?.spmStat?.scm;
      },
    },
  },
};

export default StoreConfig;
